import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/auth/login/page";
import Misafir from "../pages/misafir/page";
import PanelLayout from "../components/feature/PanelLayout";
import StudentLayout from "../components/feature/StudentLayout";
import Dashboard from "../pages/panel/dashboard/page";
import Program from "../pages/panel/program/page";
import Dersler from "../pages/panel/dersler/page";
import Kayitlar from "../pages/panel/kayitlar/page";
import Dokumanlar from "../pages/panel/dokumanlar/page";
import Odevler from "../pages/panel/odevler/page";
import Ogrenciler from "../pages/panel/ogrenciler/page";
import Gruplar from "../pages/panel/gruplar/page";
import Duyurular from "../pages/panel/duyurular/page";
import Whatsapp from "../pages/panel/whatsapp/page";
import Odeme from "../pages/panel/odeme/page";
import Raporlar from "../pages/panel/raporlar/page";
import Ayarlar from "../pages/panel/ayarlar/page";
import Yardim from "../pages/panel/yardim/page";
import StudentHome from "../pages/ogrenci/home/page";
import StudentProgram from "../pages/ogrenci/program/page";
import StudentKayitlar from "../pages/ogrenci/kayitlar/page";
import StudentDokumanlar from "../pages/ogrenci/dokumanlar/page";
import StudentDuyurular from "../pages/ogrenci/duyurular/page";
import StudentWhatsapp from "../pages/ogrenci/whatsapp/page";
import StudentOdevler from "../pages/ogrenci/odevler/page";
import StudentProfil from "../pages/ogrenci/profil/page";
import { TeacherGuard, StudentGuard } from "../components/feature/AuthGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/giris" replace />,
  },
  {
    path: "/giris",
    element: <Login />,
  },
  {
    path: "/misafir",
    element: <Misafir />,
  },
  {
    path: "/panel",
    element: <TeacherGuard />,
    children: [
      {
        element: <PanelLayout />,
        children: [
          { index: true, element: <Dashboard /> },
          { path: "program", element: <Program /> },
          { path: "dersler", element: <Dersler /> },
          { path: "kayitlar", element: <Kayitlar /> },
          { path: "dokumanlar", element: <Dokumanlar /> },
          { path: "odevler", element: <Odevler /> },
          { path: "ogrenciler", element: <Ogrenciler /> },
          { path: "gruplar", element: <Gruplar /> },
          { path: "duyurular", element: <Duyurular /> },
          { path: "whatsapp", element: <Whatsapp /> },
          { path: "odeme", element: <Odeme /> },
          { path: "raporlar", element: <Raporlar /> },
          { path: "ayarlar", element: <Ayarlar /> },
          { path: "yardim", element: <Yardim /> },
        ],
      },
    ],
  },
  {
    path: "/ogrenci",
    element: <StudentGuard />,
    children: [
      {
        element: <StudentLayout />,
        children: [
          { index: true, element: <StudentHome /> },
          { path: "program", element: <StudentProgram /> },
          { path: "kayitlar", element: <StudentKayitlar /> },
          { path: "dokumanlar", element: <StudentDokumanlar /> },
          { path: "odevler", element: <StudentOdevler /> },
          { path: "duyurular", element: <StudentDuyurular /> },
          { path: "whatsapp", element: <StudentWhatsapp /> },
          { path: "profil", element: <StudentProfil /> },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;